/**
 * Phase 40 — the pool's add picker lists EVERY route of the country: a route
 * already in the pool reads "… — add a 2nd lane (other sender IDs)", since
 * the same gateway may sit in the pool twice with other sender IDs.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { Gateway } from '@/hooks/smswiser/core/useSMSWiser';

import type { DraftPoolRow } from '../../../../drop-generator.types';

export const ordinal = (n: number): string => {
  const tail = n % 100 >= 11 && n % 100 <= 13 ? 'th' : (['th', 'st', 'nd', 'rd'][n % 10] ?? 'th');
  return `${n}${tail}`;
};

export interface LaneAddOption {
  value: string;
  label: string;
}

export function laneAddOptions(routes: readonly Gateway[], pool: readonly DraftPoolRow[]): LaneAddOption[] {
  return routes.map((r) => {
    const lanes = pool.filter((l) => l.routeId === r.id).length;
    const price = r.pricePerSms != null ? ` · $${Number(r.pricePerSms).toFixed(3)}/SMS` : '';
    const again = lanes > 0 ? ` — add a ${ordinal(lanes + 1)} lane (other sender IDs)` : '';
    return { value: String(r.id), label: `${r.name}${price}${again}` };
  });
}
